export const COOKIE_SEGMENT_VALIDATED = 'segment_validated';

export const RDW_ID = {
	cookie: 'rwd_id',
};

export const COOKIE_TD = {
	cookie: '_td',
};

export const SEARCH_BAR = 'search-bar';
export const PROMO_WRAPPER = 'promo-wrapper';

export const UPDATE_RESULTS_EVENT = 'update-results';

export const CRUISE_SORT = 'cruise sort';

export const FAVORITES_SIZE_BUTTON = 24;
